(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-default-widget-gutenberg-block', {

        // Block setup
        title: __('Discord Default Widget', 'discord-wordpress-plugin'),
        description: __('The same widget that you will get by copying HTML iFrame code from Discord client.', 'discord-wordpress-plugin'),
        icon: <svg width="512" height="512">
                <path fill="#7289DA" d="M3.6,21.2h14.3L17.2,19l1.6,1.4l1.5,1.3L23,24V2.5C22.9,1.1,21.8,0,20.4,0L3.6,0C2.2,0,1,1.1,1,2.5v16.2 C1,20.1,2.2,21.2,3.6,21.2z M14.1,5.7L14.1,5.7L14.1,5.7L14.1,5.7z M6.5,7C8.3,5.6,10,5.7,10,5.7l0.1,0.1C7.9,6.4,6.9,7.4,6.9,7.4 S7.2,7.2,7.7,7c3-1.2,6.3-1.1,9.4,0.4c0,0-1-0.9-3.1-1.5l0.2-0.2c0.3,0,1.8,0.1,3.5,1.3c0,0,1.8,3.2,1.8,7c-0.1-0.1-1.1,1.7-3.9,1.7 c0,0-0.5-0.5-0.8-1c1.6-0.5,2.2-1.4,2.2-1.4c-0.5,0.3-1,0.5-1.4,0.7c-0.6,0.3-1.2,0.4-1.8,0.5c-2.9,0.5-4.5-0.3-6-0.9l-0.5-0.3 c0,0,0.6,0.9,2.2,1.4c-0.4,0.5-0.8,1-0.8,1C5.7,15.7,4.7,14,4.7,14C4.7,10.1,6.5,7,6.5,7z M14.3,12.8c0.7,0,1.3-0.6,1.3-1.3 c0-0.7-0.6-1.3-1.3-1.3v0c-0.7,0-1.3,0.6-1.3,1.3C13,12.2,13.6,12.8,14.3,12.8z M9.7,12.8c0.7,0,1.3-0.6,1.3-1.3 c0-0.7-0.6-1.3-1.3-1.3l0,0c-0.7,0-1.3,0.6-1.3,1.3C8.4,12.2,9,12.8,9.7,12.8z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            height: {
                type: 'integer',
                default: 350,
            },
            color: {
                type: 'string',
                default: 'light',
            },
            guild: {
                type: 'string',
                default: '0',
            }
        },

        example: {},


        // Main editor function
        edit: props => {

            // Updating connected guild id
            if (props.attributes.guild === '0') {
                $.get( ajaxurl, { action: 'dwpp_getConnectedGuildId' } )
                    .done( response => props.setAttributes( { guild: response.data.id ?? '0' } ) );

                return __('Loading...', 'discord-wordpress-plugin');
            }

            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Colors', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ color: value }) }
                                    options={[
                                        { value: 'light', label: __('Light Style', 'discord-wordpress-plugin') },
                                        { value: 'dark', label: __('Dark Style', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.color }/>
                            </PanelRow>
                            <PanelRow>
                                <TextControl
                                    label={ __('Height', 'discord-wordpress-plugin') }
                                    value={ props.attributes.height }
                                    type={'number'}
                                    onChange={ value => props.setAttributes({ height: parseInt(value) > 300 ? value : 300 }) }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <iframe
                    style={{ width: '100%', border: 0 }}
                    allowFullScreen={true}
                    frameBorder={0}
                    height={props.attributes.height}
                    width='100%'
                    src={'https://discordapp.com/widget?id=' + props.attributes.guild + '&theme=' + props.attributes.color}/>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
